
class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.brandTopbarSelector = ".brand-topbar";
    this.searchToggleSelector = "#searchToggle";
    this.searchFormSelector = "#searchFormWrapper";

    this.desktopBreakpoint = 992;

    this._listeners = [];
  }

  connectedCallback() {
    this.setupStickyHeader();
    this.setupSearchToggle();
    this.initBrandSwitcherDetection();
  }

  disconnectedCallback() {
    this._listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    this._listeners = [];

    document.documentElement.style.removeProperty("--brand-active-color");
  }

  setupStickyHeader() {
    const topbar = this.querySelector(this.brandTopbarSelector);
    if (!topbar) return;

    const threshold = 60;
    const update = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (window.innerWidth < this.desktopBreakpoint) {
        topbar.classList.remove("is-fixed");
        return;
      }
      topbar.classList.toggle("is-fixed", scrollY > threshold);
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    this._listeners.push({ element: window, event: "scroll", handler: update });
    this._listeners.push({ element: window, event: "resize", handler: update });
  }

  // ===== Search Toggle =====
  setupSearchToggle() {
    const toggle = this.querySelector(this.searchToggleSelector);
    const wrapper = this.querySelector(this.searchFormSelector);
    if (!toggle || !wrapper) return;

    const searchIconUrl = toggle.dataset.iconSearch;
    const closeIconUrl = toggle.dataset.iconClose;

    const onClick = () => {
      wrapper.classList.toggle("d-none");
      const isNowOpen = !wrapper.classList.contains("d-none");

      const iconUrl = isNowOpen ? closeIconUrl : searchIconUrl;
      toggle.innerHTML = `
        <img src="${iconUrl}" alt="${isNowOpen ? "Close" : "Search"}"
             class="icon-img" style="width: 24px; height: 24px;">
      `;

      if (isNowOpen) {
        const input = wrapper.querySelector("input[type='search']");
        if (input) input.focus();
      }
    };

    toggle.addEventListener("click", onClick);
    this._listeners.push({ element: toggle, event: "click", handler: onClick });
  }

  // ===== Brand Switcher =====
  initBrandSwitcherDetection() {
    const brandSwitchers = this.querySelectorAll("brand-switcher");
    if (!brandSwitchers.length) return;

    brandSwitchers.forEach(sw => {
      const handler = (e) => this.updateBrandColor(e.detail.color);
      sw.addEventListener("brand:changed", handler);
      this._listeners.push({ element: sw, event: "brand:changed", handler });
    });
  }

  updateBrandColor(color) {
    document.documentElement.style.setProperty("--brand-active-color", color || "#000");
  }
}

customElements.define("site-header", SiteHeader);
